import { render, staticRenderFns } from "./AdminNewKunde.vue?vue&type=template&id=caf61646&"
import script from "./AdminNewKunde.vue?vue&type=script&lang=js&"
export * from "./AdminNewKunde.vue?vue&type=script&lang=js&"
import style0 from "./AdminNewKunde.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports